import { render, staticRenderFns } from "./openDetail.vue?vue&type=template&id=dfa23d6a&scoped=true"
import script from "./openDetail.vue?vue&type=script&lang=js"
export * from "./openDetail.vue?vue&type=script&lang=js"
import style0 from "./openDetail.vue?vue&type=style&index=0&id=dfa23d6a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa23d6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa23d6a')) {
      api.createRecord('dfa23d6a', component.options)
    } else {
      api.reload('dfa23d6a', component.options)
    }
    module.hot.accept("./openDetail.vue?vue&type=template&id=dfa23d6a&scoped=true", function () {
      api.rerender('dfa23d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/sendRecord/openDetail.vue"
export default component.exports